export const ACCOUNT = "ACCOUNT"
export const ADMIN = "ADMIN"
export const BOTS = "BOTS"
export const DEV_TOOLS = "DEV_TOOLS"
export const HOME = "HOME"
export const INTERNAL = "INTERNAL"
export const MEDICAL = "MEDICAL"
export const ONLINEGP = "ONLINEGP"
export const SAVINGS = "SAVINGS"
export const ONBOARDING = "ONBOARDING"
export const PERKS = "PERKS"
export const FLEXIREWARDS = "FLEXIREWARDS"
export const PLATFORM = "PLATFORM"
export const PUBLIC = "PUBLIC"
export const RECOGNITION = "RECOGNITION"
export const REWARD = "REWARD"
export const CONTRACT = "CONTRACT"
export const SEARCH = "SEARCH"
export const WALLET = "WALLET"
export const WELLNESS = "WELLNESS"
export const WELCOME = "WELCOME"
export const CULTUREHUB = "CULTUREHUB"
export const BENEFITS = "BENEFITS"
export const CYCLETOWORK = "CYCLETOWORK"
export const HOMEANDELECTRONICS = "HOMEANDELECTRONICS"
export const ANNUALLEAVEPURCHASE = "ANNUALLEAVEPURCHASE"

export default {
  [ACCOUNT]: "/account",
  [ADMIN]: "/admin",
  [BOTS]: "/bots",
  [DEV_TOOLS]: "/dev-tools",
  [HOME]: "/home",
  [INTERNAL]: "/internal",
  [MEDICAL]: "/medical",
  [ONLINEGP]: "/online-gp",
  [SAVINGS]: "/my-savings",
  [ONBOARDING]: "/onboard",
  [PERKS]: "/perks",
  [FLEXIREWARDS]: "/rewards",
  [PLATFORM]: "/",
  [PUBLIC]: "/public",
  [RECOGNITION]: "/recognition",
  [SEARCH]: "/search",
  [WALLET]: "/wallet",
  [WELLNESS]: "/wellness",
  [WELCOME]: "/welcome",
  [CULTUREHUB]: "/culture-hub",
  [BENEFITS]: "/benefits",
  [CYCLETOWORK]: "/cycle_to_work",
  [HOMEANDELECTRONICS]: "/home_and_electronics",
  [ANNUALLEAVEPURCHASE]: "/annual_leave_purchase",
}
